import React, { useCallback } from 'react';
import { ClipboardText } from '@ydistri/ds';
import { useAppDispatch } from '../../../store';
import { addToast } from '@ydistri/utils';

interface ClipboardTextWithToastProps {
  text: number | string;
  textToCopy?: string;
}

/**
 * Ydistri app wrapper for ClipboardText that automatically shows toast notifications
 * when text is copied to clipboard or when an error occurs.
 */
export const ClipboardTextWithToast: React.FC<ClipboardTextWithToastProps> = ({
  text,
  textToCopy,
}) => {
  const dispatch = useAppDispatch();

  const handleCopy = useCallback(
    (copiedText: string) => {
      dispatch(addToast({ message: `Value '${copiedText}' copied to clipboard` }));
    },
    [dispatch],
  );

  const handleError = useCallback(
    (failedText: string, error: Error) => {
      dispatch(
        addToast({
          message: `Failed to copy '${failedText}' to clipboard: ${error.message}`,
          isError: true,
        }),
      );
    },
    [dispatch],
  );

  return (
    <ClipboardText text={text} textToCopy={textToCopy} onCopy={handleCopy} onError={handleError} />
  );
};
